import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject, finalize, of, throwError } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    switchMap,
    catchError,
    tap,
    map,
    takeUntil,
} from 'rxjs/operators';
import { helper } from 'src/environments/helper';
import { NotificationService } from '../../../services/notification.service';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { DestinatieTableDataRow, DocumentData, EntityDocument, FileUpload, GeneralData } from '../document.interface';
import { formatDate } from '@angular/common';
import { SearchEntitate } from '../../entitati/entitati.interface';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';
import { ToastService } from 'src/app/services/toast.service';
import { EmailAttachment, EmailRecord, EmailRecordDetail } from '../../inbox/inbox.interface';
import { InboxService } from '../../inbox/inbox.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface Sursa {
    id: number,
    name: string,
}

@Component({
    selector: 'app-doc-intrare',
    templateUrl: './doc-intrare.component.html',
    styleUrls: ['./doc-intrare.component.scss']
})
export class DocIntrareComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    today: Date = new Date();
    isLoading = false;
    isSelectedEmailLoading = false;
    uploading = false;
    showEmitentInfoForm = true;

    // showRegistreFields = true;
    showFormFiles = false;
    showFormDestinatie = false;

    docData: DocumentData | null = null;

    inboxEmailsData: EmailRecord[] | null = null;
    inboxAttachementsData: {
        selectedEmail: EmailRecordDetail,
        selectedAttachments: EmailAttachment[]
    } | null = null;
    selectedEmail: EmailRecordDetail | null = null;

    showEmailList = false;
    currentEmailIndex = 0;
    selectedInboxEmail: EmailRecordDetail | null = null;

    tableData: DestinatieTableDataRow[] = [];

    defaultTaraId: number | null = null;
    defaultTaraLabel: string = '';
    defaultJudetId: number | null = null;
    defaultJudetLabel: string = '';
    defaultLocalitateId: number | null = null;
    defaultLocalitateLabel: string = '';

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    newNumberOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Emitere cu număr existent din registru selectat: ',
            id: 1,
        },
        {
            name: 'Număr nou/la rând',
            id: 2,
        },
    ];

    registreOptions: { name: string; id: number }[] = [
        {
            name: 'Număr din oficiu/nou',
            id: 1,
        },
        {
            name: 'Număr anterior, intern zi curentă',
            id: 2,
        },
    ];

    proceduriDocumentOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Preluare număr pentru pregătire documentație',
            id: 1,
        },
        {
            name: 'Transmitere către alte Servicii/Compartimente',
            id: 2,
        },
    ];

    form: FormGroup = new FormGroup({
        id_categorie: new FormControl(1, []), // Hard coded for doc intrare

        new_number: new FormControl(-1, []),
        id_serie: new FormControl(-1, []),
        exit_document_format: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        source: new FormControl(-1, []),
        // sourceArr: this.fb.array([]), // Added in submitForm!
        id_tip_document: new FormControl(null, [Validators.required]),
        name_tip_document: new FormControl('', [Validators.required]),

        parent_no: new FormControl('', []),
        parent_year: new FormControl(2025, []),
        serie_pv: new FormControl('', []),
        extern_numar: new FormControl('', []),
        extern_date_input: new FormControl('', []),
        // extern_date: new FormControl('', []), // Added in submitForm!
        data_comunicare_pv_input: new FormControl('', []),
        // data_comunicare_pv: new FormControl('', []), // Added in submitForm!
        observatii: new FormControl('', [Validators.required]),
        keywords: new FormControl('', [Validators.required]),
        no_pages: new FormControl('', [Validators.required]),

        registratura_number_type: new FormControl(1, []), // For inbox
        registratura_number: new FormControl(null, []), // For inbox

        // needed ?
        // id_print: new FormControl(0, []),
        // instiintare: this.fb.array([]),
        // document_compartiment: new FormControl(-1, []),
        // id_petent_pv: new FormControl('', []),
        // rezervare_date: new FormControl('', []),
        // data_pv: new FormControl('', []),
    });

    formEmitent: FormGroup = new FormGroup({
        type: new FormControl(1, []), // Hard coded emitent
        id: new FormControl(null, []), // needed ?
        id_address_type: new FormControl(1, []), // Cetatean default!
        denumire: new FormControl('', []),
        pers_contact: new FormControl('', []),
        denumire_select: new FormControl('', []),
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        cnp_cui: new FormControl('', [Validators.required]), // Cetatean default!
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        numar_deces: new FormControl('', []),
        data_deces_input: new FormControl('', []),
        person_status: new FormControl(false, []),
        observatii: new FormControl('', []),
    });

    formExtern: FormGroup = new FormGroup({
        type: new FormControl(1, []), // Hard coded emitent
        denumire: new FormControl('', []),
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        observatii: new FormControl('', []),
    })

    formFiles: FormGroup = new FormGroup({
        files: this.fb.array([], [Validators.required]),
    })

    formDestinatie: FormGroup = new FormGroup({
        // id: new FormControl('', []), // Added in submitForm!
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        // dosar_original: new FormControl('', []) // Added in addDestinatieToTableData!
    });

    private destroy$ = new Subject<void>();

    registreActiveSwitch: Generic[] = [];

    surse: Generic[] = [];
    sourceArr: Sursa[] = [];

    tipDocumente: Generic[] = [];
    tipDocumenteControl = new FormControl('', [Validators.required]);
    isTipDocumenteLoading = false;
    showTipDocumenteMessage = true;
    tipDocumenteLoadComplete = false;

    entitatiEmitent: SearchEntitate[] = [];
    entitatiEmitentControl = new FormControl();
    isEntitatiEmitentLoading = false;
    showEntitatiEmitentMessage = true;
    entitatiEmitentLoadComplete = false;

    entitatiEmitentByCNP: SearchEntitate[] = [];
    entitatiEmitentByCNPControl: FormControl<any> = new FormControl('', [Validators.required]);
    isEntitatiEmitentByCNPLoading = false;
    showEntitatiEmitentByCNPMessage = true;
    entitatiEmitentByCNPLoadComplete = false;

    directiiEmitent: Generic[] = [];
    filteredDirectiiEmitent: Generic[] = [];
    directiiEmitentControl = new FormControl();

    compartimenteEmitent: GenericCompartimentSearch[] = [];
    compartimenteEmitentControl = new FormControl();
    isCompartimenteEmitentLoading = false;
    showCompartimenteEmitentMessage = true;
    compartimenteEmitentLoadComplete = false;

    operatoriEmitent: Generic[] = [];
    filteredOperatoriEmitent: Generic[] = [];
    operatoriEmitentControl = new FormControl();

    directiiDestinatie: Generic[] = [];
    filteredDirectiiDestinatie: Generic[] = [];
    directiiDestinatieControl = new FormControl();

    compartimenteDestinatie: GenericCompartimentSearch[] = [];
    compartimenteDestinatieControl = new FormControl();
    isCompartimenteDestinatieLoading = false;
    showCompartimenteDestinatieMessage = true;
    compartimenteDestinatieLoadComplete = false;

    operatoriDestinatie: Generic[] = [];
    filteredOperatoriDestinatie: Generic[] = [];
    operatoriDestinatieControl = new FormControl();

    tariEmitent: Generic[] = [];
    filteredTariEmitent: Generic[] = [];
    tariEmitentControl = new FormControl();

    judeteEmitent: Generic[] = [];
    filteredJudeteEmitent: Generic[] = [];
    judeteEmitentControl = new FormControl();

    localitatiEmitent: Generic[] = [];
    localitatiEmitentControl = new FormControl();
    isLocalitatiEmitentLoading = false;
    showLocalitatiEmitentMessage = true;
    localitatiEmitentLoadComplete = false;

    straziEmitent: Generic[] = [];
    straziEmitentControl = new FormControl();
    isStraziEmitentLoading = false;
    showStraziEmitentMessage = true;
    straziEmitentLoadComplete = false;
    lastStraziEmitentValue = '';

    entitatiExtern: SearchEntitate[] = [];
    entitatiExternControl = new FormControl();
    isEntitatiExternLoading = false;
    showEntitatiExternMessage = true;
    entitatiExternLoadComplete = false;

    tariExtern: Generic[] = [];
    filteredTariExtern: Generic[] = [];
    tariExternControl = new FormControl();

    judeteExtern: Generic[] = [];
    filteredJudeteExtern: Generic[] = [];
    judeteExternControl = new FormControl();

    localitatiExtern: Generic[] = [];
    localitatiExternControl = new FormControl();
    isLocalitatiExternLoading = false;
    showLocalitatiExternMessage = true;
    localitatiExternLoadComplete = false;

    straziExtern: Generic[] = [];
    straziExternControl = new FormControl();
    isStraziExternLoading = false;
    showStraziExternMessage = true;
    straziExternLoadComplete = false;
    lastStraziExternValue = '';

    selectedSerieDocument: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData?: DocumentData,
            inboxEmailsData?: EmailRecord[],
            inboxAttachementsData?: {
                selectedEmail: EmailRecordDetail,
                selectedAttachments: EmailAttachment[]
            },
            serieId?: number | -1,
            reg_number?: string,
            idDocumentActivity?: number
        },
        private dialogRef: MatDialogRef<DocIntrareComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        private toastService: ToastService,
        private inboxService: InboxService,
        private sanitizer: DomSanitizer,
    ) {
        this.data.generalData.forEach(item => {
            if (item.name === 'default_adresa_tara' && Number(item.value) > 0 && item.label) {
                this.defaultTaraId = Number(item.value);
                this.defaultTaraLabel = item.label || '';
            } else if (item.name === 'default_adresa_judet' && Number(item.value) > 0 && item.label) {
                this.defaultJudetId = Number(item.value);
                this.defaultJudetLabel = item.label || '';
            } else if (item.name === 'default_adresa_localitate' && Number(item.value) > 0 && item.label) {
                this.defaultLocalitateId = Number(item.value);
                this.defaultLocalitateLabel = item.label || '';
            }
        })

        // If docData exists, it means the component is run from view doc!
        this.docData = data.docData ? data.docData : null;
        // If inboxEmailsData/inboxAttachementsData exists, it means the component is run from inbox!
        this.inboxEmailsData = data.inboxEmailsData ? data.inboxEmailsData : null;
        this.inboxAttachementsData = data.inboxAttachementsData ? data.inboxAttachementsData : null;
    }

    getSafeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    ngOnInit() {
        this.loadActiveSwitch();
        this.loadSurseActive();
        this.loadDirectiiActiveEmitent();
        this.loadDirectiiActiveDestinatie(0);

        this.loadTariActive();
        this.loadDefaultLocatieExtern();

        this.isLoading = true

        if (this.data.serieId) {
            this.form.controls['id_serie'].patchValue(this.data.serieId);
        }

        if (this.docData) {
            this.newNumberOptions[1].name = `Emitere cu număr existent din registru selectat: ${this.data.reg_number}`;
            this.form.controls['new_number'].setValidators([Validators.required, notDefaultValidator('-1')]);
            this.form.controls['new_number'].patchValue(1);
            this.form.controls['id_serie'].patchValue(this.data.serieId);

            // FormDestinatie is always displayed when docData exists!
            this.showFormDestinatie = true;

            // Update emitent and destinatie tableData with docData
            if (this.docData.entity) this.updateFormEmitent(this.docData.entity);
            this.docData.destinatie.forEach(item => {
                this.tableData.push({
                    id: null,
                    directie_id: item.destination_directie_id,
                    directie_name: item.destination_directie_name,
                    compartiment_id: item.destination_compartiment_id,
                    compartiment_name: item.destination_compartiment_name,
                    user_id: item.destination_user_id,
                    user_name: item.destination_user_name,
                    dosar_original: item.dosar_original === 1 ? true : false,
                })
            })
        } else {
            this.form.controls['id_serie'].setValidators([Validators.required, notDefaultValidator('-1')]);

            // Load default locatie emitent, if we don't update form emitent
            this.loadDefaultLocatieEmitent();
        }

        if (this.inboxEmailsData || this.inboxAttachementsData) {
            this.form.controls['registratura_number_type'].setValidators([Validators.required, notDefaultValidator('-1')]);
            this.form.controls['exit_document_format'].patchValue(2);
            this.onProceduraIesireSelected(2);
            this.form.controls['source'].patchValue(4); // Hard coded for email, may fail if the id is changed in BE
            this.addSerie();

            if (this.inboxEmailsData) {
                if (this.inboxEmailsData.length > 1) {
                    // Dacă sunt mai multe emailuri, arată lista
                    this.showEmailList = true;
                } else {
                    // Dacă este un singur email, încarcă-l direct
                    this.showEmailList = false;
                    this.loadSelectedEmail(this.inboxEmailsData[0].id);
                }
            }

            if (this.inboxAttachementsData) {
                this.selectedEmail = this.inboxAttachementsData.selectedEmail;
                this.formEmitent.controls['denumire_select'].patchValue(this.inboxAttachementsData.selectedEmail.from_name);
                this.formEmitent.controls['denumire'].patchValue(this.inboxAttachementsData.selectedEmail.from_name);
                this.formEmitent.controls['email'].patchValue(this.inboxAttachementsData.selectedEmail.from_email);
            }
        }

        this.tipDocumenteControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchTipDocumente(value);
                this.showTipDocumenteMessage = true;
                this.tipDocumenteLoadComplete = false;
            }
        });

        this.entitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitent(value);
                this.showEntitatiEmitentMessage = true;
                this.entitatiEmitentLoadComplete = false;
            }
        });

        this.entitatiEmitentByCNPControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitentByCNP(value);
                this.showEntitatiEmitentByCNPMessage = true;
                this.entitatiEmitentByCNPLoadComplete = false;
            }
        });

        this.compartimenteEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteEmitent(compartiment);
                this.showCompartimenteEmitentMessage = true;
                this.compartimenteEmitentLoadComplete = false;
            }
        });

        this.localitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiEmitent(localitate);
                this.showLocalitatiEmitentMessage = true;
                this.localitatiEmitentLoadComplete = false;
            }
        });

        this.straziEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziEmitent(strada);
                this.showStraziEmitentMessage = true;
                this.straziEmitentLoadComplete = false;
            }
        });

        this.entitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiExtern(value);
                this.showEntitatiExternMessage = true;
                this.entitatiExternLoadComplete = false;
            }
        });

        this.localitatiExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiExtern(localitate);
                this.showLocalitatiExternMessage = true;
                this.localitatiExternLoadComplete = false;
            }
        });

        this.straziExternControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziExtern(strada);
                this.showStraziExternMessage = true;
                this.straziExternLoadComplete = false;
            }
        });

        this.compartimenteDestinatieControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteDestinatie(compartiment, 0);
                this.showCompartimenteDestinatieMessage = true;
                this.compartimenteDestinatieLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.directiiEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiEmitent = this.directiiEmitent;
                    return of(this.directiiEmitent);
                }
                return this.filterDirectiiEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriEmitent = this.operatoriEmitent;
                    return of(this.operatoriEmitent);
                }
                return this.filterOperatoriEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiDestinatie = this.directiiDestinatie;
                    return of(this.directiiDestinatie);
                }
                return this.filterDirectiiDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriDestinatie = this.operatoriDestinatie;
                    return of(this.operatoriDestinatie);
                }
                return this.filterOperatoriDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tariEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredTariEmitent = this.tariEmitent;
                    return of(this.tariEmitent);
                }
                return this.filterTariEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteEmitent = this.judeteEmitent;
                    return of(this.judeteEmitent);
                }
                return this.filterJudeteEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tariExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredTariExtern = this.tariExtern;
                    return of(this.tariExtern);
                }
                return this.filterTariExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteExternControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteExtern);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteExtern = this.judeteExtern;
                    return of(this.judeteExtern);
                }
                return this.filterJudeteExtern(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteExtern = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    onSelectEmailFromList(email: EmailRecord, index: number) {
        this.currentEmailIndex = index;
        this.showEmailList = false;
        this.loadSelectedEmail(email.id);
    }

    onBackToEmailList() {
        this.showEmailList = true;
        this.selectedInboxEmail = null;
    }

    onPreviousEmail() {
        if (this.currentEmailIndex > 0 && this.inboxEmailsData) {
            this.currentEmailIndex--;
            this.loadSelectedEmail(this.inboxEmailsData[this.currentEmailIndex].id);
        }
    }

    onNextEmail() {
        if (this.inboxEmailsData && this.currentEmailIndex < this.inboxEmailsData.length - 1) {
            this.currentEmailIndex++;
            this.loadSelectedEmail(this.inboxEmailsData[this.currentEmailIndex].id);
        }
    }

    loadSelectedEmail(id: number) {
        this.isSelectedEmailLoading = true;

        this.inboxService.find(id)
            .pipe(
                finalize(() => this.isSelectedEmailLoading = false)
            )
            .subscribe({
                next: (response: any) => {
                    if (response && response.data) {
                        this.selectedEmail = response.data;
                        this.selectedInboxEmail = response.data;
                        if (this.selectedEmail) {
                            this.formEmitent.controls['denumire_select'].patchValue(this.selectedEmail.from_name);
                            this.formEmitent.controls['denumire'].patchValue(this.selectedEmail.from_name);
                            this.formEmitent.controls['email'].patchValue(this.selectedEmail.from_email);
                        }
                    }
                },
                error: (err) => {
                    console.error('Error loading email details:', err);
                }
            });
    }

    loadActiveSwitch() {
        this.isLoading = true;
        this.commonService
            .getActiveSwitch()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.registreActiveSwitch = results;

                    this.isLoading = false;

                    // this formula is needed for only where we have ID Document or ID Document Activity BINDED
                    if (this.data.serieId && this.data.serieId !== -1) {
                        const foundSerie = this.registreActiveSwitch.find((obj: Generic) =>
                            Number(obj.id) === this.data.serieId
                        );
                        this.selectedSerieDocument = foundSerie?.name || null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    } else {
                        this.selectedSerieDocument = this.docData?.serie?.name ? this.docData.serie.name : null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    }
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                },
            });
    }

    loadSurseActive() {
        this.isLoading = true;
        this.commonService
            .getSurseActive()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.surse = results;
                    this.addSerie();
                },
                error: (error) => {
                    console.error('Error loading surse', error);
                    this.isLoading = false;
                },
            });
    }

    fetchTipDocumente(search: string) {
        if (search && search.length >= 2) {
            this.isTipDocumenteLoading = true;
            this.commonService.searchTipDocumente(search).subscribe({
                next: (response: Generic[]) => {
                    this.tipDocumente = response;
                    this.isTipDocumenteLoading = false;
                    this.tipDocumenteLoadComplete = true;
                    this.showTipDocumenteMessage = this.tipDocumente.length === 0;
                },
                error: (err: any) => {
                    this.isTipDocumenteLoading = false;
                    this.showTipDocumenteMessage = true;
                    this.tipDocumenteLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.tipDocumente = [];
            this.showTipDocumenteMessage = true;
            this.tipDocumenteLoadComplete = false;
        }
    }

    onTipDocumenteSelected(selectedDocument: Generic) {
        if (selectedDocument) {
            this.form.controls['id_tip_document'].patchValue(selectedDocument.id);
            this.form.controls['name_tip_document'].patchValue(selectedDocument.name);
        }
    }

    displayTipDocumente(selectedDocument: Generic): string {
        return selectedDocument && selectedDocument.name ? selectedDocument.name : '';
    }

    onTipDocumenteBlur() {
        const currentValue = this.tipDocumenteControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tipDocumenteControl.patchValue('');
            this.form.controls['id_tip_document'].patchValue('');
            this.form.controls['name_tip_document'].patchValue('');
        }
    }

    fetchEntitatiEmitent(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiEmitentLoading = true;
            this.commonService.searchEntitati(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitent = response;
                    this.isEntitatiEmitentLoading = false;
                    this.entitatiEmitentLoadComplete = true;
                    this.showEntitatiEmitentMessage = this.entitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentLoading = false;
                    this.showEntitatiEmitentMessage = true;
                    this.entitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitent = [];
            this.showEntitatiEmitentMessage = true;
            this.entitatiEmitentLoadComplete = false;
        }
    }

    onEntitateEmitentSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'name');
        }
    }

    displayEntitateEmitent(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateEmitentChange() {
        const currentValue = this.entitatiEmitentControl.value;

        if (typeof currentValue === 'string') {
            this.formEmitent.controls['id'].patchValue(null);
            this.formEmitent.controls['denumire_select'].patchValue(currentValue);
        }
    }

    fetchEntitatiEmitentByCNP(cnp: string) {
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;

        if (cnp && cnp.length >= 2) {
            this.isEntitatiEmitentByCNPLoading = true;
            this.commonService.searchEntitatiByCNP(cnp, currentEntitateType).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitentByCNP = response;
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    this.showEntitatiEmitentByCNPMessage = this.entitatiEmitentByCNP.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.showEntitatiEmitentByCNPMessage = true;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitentByCNP = [];
            this.showEntitatiEmitentByCNPMessage = true;
            this.entitatiEmitentByCNPLoadComplete = false;
        }
    }

    onEntitateEmitentByCNPSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'cnp');
        }
    }

    displayEntitateEmitentByCNP(entitate: SearchEntitate): string {
        return entitate && entitate.cnp_cui ? entitate.cnp_cui : '';
    }

    onEntitateEmitentByCNPChange() {
        const currentValue = this.entitatiEmitentByCNPControl.value;

        if (typeof currentValue === 'string') {
            this.formEmitent.controls['id'].patchValue(null);
            this.formEmitent.controls['cnp_cui'].patchValue(currentValue);
        }
    }

    updateFormEmitent(selectedEntitate: SearchEntitate | EntityDocument, updateType?: 'name' | 'cnp') {
        const selectedEntitateType = selectedEntitate.id_address_type;
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;
        const searchedEntitati = this.entitatiEmitent;
        const searchedEntitatiByCNP = this.entitatiEmitentByCNP;

        if (selectedEntitateType !== currentEntitateType) {
            this.formEmitent.get('id_address_type')?.patchValue(selectedEntitateType);
            this.resetFormEmitent(selectedEntitateType);
        }

        if (updateType === 'name') {
            this.entitatiEmitent = searchedEntitati;
            this.entitatiEmitentByCNP = []
        }
        if (updateType === 'cnp') {
            this.entitatiEmitentByCNP = searchedEntitatiByCNP;
            this.entitatiEmitent = [];
        }

        if (selectedEntitateType === 1 || selectedEntitateType === 2 || selectedEntitateType === 3) {
            this.entitatiEmitentControl.setValue(selectedEntitate);
            this.formEmitent.get('id')?.patchValue(selectedEntitate.id);
            this.formEmitent.get('denumire_select')?.patchValue(selectedEntitate.denumire);
            this.formEmitent.get('denumire')?.patchValue(selectedEntitate.denumire);

            if (selectedEntitateType === 2 || selectedEntitateType === 3) {
                this.formEmitent.get('pers_contact')?.patchValue(selectedEntitate.pers_contact);
            }
            if (selectedEntitateType === 1 || selectedEntitateType === 2) {
                this.entitatiEmitentByCNPControl.setValue(selectedEntitate);
                this.formEmitent.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);
                this.formEmitent.get('email')?.patchValue(selectedEntitate.email);
                this.formEmitent.get('telefon')?.patchValue(selectedEntitate.telefon);
            }
            if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
                this.tariEmitentControl.setValue({
                    id: selectedEntitate.id_tara,
                    name: selectedEntitate.name_tara
                })
                this.formEmitent.get('id_tara')?.patchValue(selectedEntitate.id_tara);
                this.formEmitent.get('name_tara')?.patchValue(selectedEntitate.name_tara);
                this.loadJudeteEmitent(selectedEntitate.id_tara);
            }
            if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
                this.judeteEmitentControl.setValue({
                    id: selectedEntitate.id_judet,
                    name: selectedEntitate.name_judet
                })
                this.formEmitent.get('id_judet')?.patchValue(selectedEntitate.id_judet);
                this.formEmitent.get('name_judet')?.patchValue(selectedEntitate.name_judet);
            }
            if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
                this.fetchLocalitatiEmitent(selectedEntitate.name_localitate);
                this.localitatiEmitentControl.setValue({
                    id: selectedEntitate.id_localitate,
                    name: selectedEntitate.name_localitate
                })
                this.formEmitent.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
                this.formEmitent.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
            }
            if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
                this.fetchStraziEmitent(selectedEntitate.name_strada);
                this.straziEmitentControl.setValue({
                    id: selectedEntitate.id_strada,
                    name: selectedEntitate.name_strada
                })
                this.formEmitent.get('id_strada')?.patchValue(selectedEntitate.id_strada);
                this.formEmitent.get('name_strada')?.patchValue(selectedEntitate.name_strada);
            }

            this.formEmitent.get('sector')?.patchValue(selectedEntitate.sector);
            this.formEmitent.get('numar')?.patchValue(selectedEntitate.numar);
            this.formEmitent.get('bloc')?.patchValue(selectedEntitate.bloc);
            this.formEmitent.get('scara')?.patchValue(selectedEntitate.scara);
            this.formEmitent.get('apartament')?.patchValue(selectedEntitate.apartament);
            this.formEmitent.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
            this.formEmitent.get('numar_deces')?.patchValue(selectedEntitate.numar_deces);
            this.formEmitent.get('data_deces_input')?.patchValue(selectedEntitate.data_deces);
        }
    }

    loadDirectiiActiveEmitent() {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiEmitent = results;

                    this.filteredDirectiiEmitent = [...this.directiiEmitent];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiEmitent = [];
                },
            });
    }

    loadDirectiiActiveDestinatie(blocked: number) {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive(blocked)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiDestinatie = results;

                    this.filteredDirectiiDestinatie = [...this.directiiDestinatie];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiDestinatie = [];
                },
            });
    }

    onDirectiiEmitentChange(selectedCompartiment: Generic): void {
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteEmitentControl.patchValue('');
        this.formEmitent.controls['compartiment_id'].patchValue('');
        this.formEmitent.controls['compartiment_name'].patchValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayDirectiiEmitent(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiEmitentBlur() {
        const currentValue = this.directiiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiEmitentControl.patchValue('');
            this.formEmitent.controls['directie_id'].patchValue('');
            this.formEmitent.controls['directie_name'].patchValue('');

            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteEmitent(compartiment: string) {
        // const directieEmitentValue = this.formEmitent.get('directie_id')?.value;
        // const directie = directieEmitentValue && directieEmitentValue !== -1 ? directieEmitentValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteEmitentLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteEmitent = response;
                    this.isCompartimenteEmitentLoading = false;
                    this.compartimenteEmitentLoadComplete = true;
                    this.showCompartimenteEmitentMessage = this.compartimenteEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteEmitentLoading = false;
                    this.showCompartimenteEmitentMessage = true;
                    this.compartimenteEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteEmitent = [];
            this.showCompartimenteEmitentMessage = true;
            this.compartimenteEmitentLoadComplete = false;
        }
    }

    onCompartimenteEmitentSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formEmitent.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiEmitentControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriEmitent();
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayCompartimenteEmitent(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteEmitentBlur() {
        const currentValue = this.compartimenteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriEmitent() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formEmitent.controls['directie_id'].value,
            compartiment_id: this.formEmitent.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriEmitent = [...data];
                    this.filteredOperatoriEmitent = [...this.operatoriEmitent];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriEmitent = [];
                },
            });
    }

    // onOperatoriEmitentClosed() {
    //     const selectedValue = this.operatoriEmitentControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriEmitent.some(operator =>
    //             operator.id === this.formEmitent.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriEmitentControl.setValue(null);
    //             this.filteredOperatoriEmitent = this.operatoriEmitent;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriEmitentChange(operatorId: number): void {
        const selectedOperator = this.operatoriEmitent.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formEmitent.controls['user_id'].patchValue(selectedOperator.id);
            this.formEmitent.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriEmitent(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriEmitentBlur() {
    //     const currentValue = this.operatoriEmitentControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriEmitentControl.patchValue('');
    //         this.formEmitent.controls['user_id'].patchValue('');
    //         this.formEmitent.controls['user_name'].patchValue('');
    //     }
    // }

    onDirectiiDestinatieChange(selectedCompartiment: Generic): void {
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteDestinatieControl.patchValue('');
        this.formDestinatie.controls['compartiment_id'].patchValue('');
        this.formDestinatie.controls['compartiment_name'].patchValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayDirectiiDestinatie(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiDestinatieBlur() {
        const currentValue = this.directiiDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiDestinatieControl.patchValue('');
            this.formDestinatie.controls['directie_id'].patchValue('');
            this.formDestinatie.controls['directie_name'].patchValue('');

            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteDestinatie(compartiment: string, blocked: number) {
        // const directieDestinatieValue = this.formDestinatie.get('directie_id')?.value;
        // const directie = directieDestinatieValue && directieDestinatieValue !== -1 ? directieDestinatieValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteDestinatieLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment, blocked).subscribe({
                next: (response: any) => {
                    this.compartimenteDestinatie = response;
                    this.isCompartimenteDestinatieLoading = false;
                    this.compartimenteDestinatieLoadComplete = true;
                    this.showCompartimenteDestinatieMessage = this.compartimenteDestinatie.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteDestinatieLoading = false;
                    this.showCompartimenteDestinatieMessage = true;
                    this.compartimenteDestinatieLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteDestinatie = [];
            this.showCompartimenteDestinatieMessage = true;
            this.compartimenteDestinatieLoadComplete = false;
        }
    }

    onCompartimenteDestinatieSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formDestinatie.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiDestinatieControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriDestinatie();
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayCompartimenteDestinatie(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteDestinatieBlur() {
        const currentValue = this.compartimenteDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriDestinatie() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formDestinatie.controls['directie_id'].value,
            compartiment_id: this.formDestinatie.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriDestinatie = [...data];
                    this.filteredOperatoriDestinatie = [...this.operatoriDestinatie];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriDestinatie = [];
                },
            });
    }

    // onOperatoriDestinatieClosed() {
    //     const selectedValue = this.operatoriDestinatieControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriDestinatie.some(operator =>
    //             operator.id === this.formDestinatie.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriDestinatieControl.setValue(null);
    //             this.filteredOperatoriDestinatie = this.operatoriDestinatie;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriDestinatieChange(operatorId: number): void {
        const selectedOperator = this.operatoriDestinatie.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formDestinatie.controls['user_id'].patchValue(selectedOperator.id);
            this.formDestinatie.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriDestinatie(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriDestinatieBlur() {
    //     const currentValue = this.operatoriDestinatieControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriDestinatieControl.patchValue('');
    //         this.formDestinatie.controls['user_id'].patchValue('');
    //         this.formDestinatie.controls['user_name'].patchValue('');
    //     }
    // }

    loadTariActive() {
        this.isLoading = true;
        this.commonService
            .getTariActive()
            .pipe(
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tariEmitent = results;
                    this.tariExtern = results;
                    this.filteredTariEmitent = [...this.tariEmitent];
                    this.filteredTariExtern = [...this.tariExtern];
                },
                error: (error) => {
                    console.error('Error loading tari', error);
                    this.filteredTariEmitent = [];
                    this.filteredTariExtern = [];
                },
            });
    }

    onTariEmitentChange(selectedTara: Generic): void {
        this.formEmitent.controls['id_tara'].patchValue(selectedTara.id);
        this.formEmitent.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteEmitent(selectedTara.id);
        this.judeteEmitentControl.patchValue('');
        this.formEmitent.controls['id_judet'].patchValue('');
        this.formEmitent.controls['name_judet'].patchValue('');

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayTariEmitent(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariEmitentBlur() {
        const currentValue = this.tariEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariEmitentControl.patchValue('');
            this.formEmitent.controls['id_tara'].patchValue('');
            this.formEmitent.controls['name_tara'].patchValue('');

            this.judeteEmitent = [];
            this.filteredJudeteEmitent = [];
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteEmitent(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteEmitent = results;
                    this.filteredJudeteEmitent = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteEmitent = [];
                },
            });
    }

    onJudeteEmitentChange(selectedJudet: Generic): void {
        this.formEmitent.controls['id_judet'].patchValue(selectedJudet.id);
        this.formEmitent.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayJudeteEmitent(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteEmitentBlur() {
        const currentValue = this.judeteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiEmitent(localitate: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? this.formEmitent.get('id_tara')?.value : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? this.formEmitent.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiEmitentLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiEmitent = response;
                    this.isLocalitatiEmitentLoading = false;
                    this.localitatiEmitentLoadComplete = true;
                    this.showLocalitatiEmitentMessage = this.localitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiEmitentLoading = false;
                    this.showLocalitatiEmitentMessage = true;
                    this.localitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiEmitent = [];
            this.showLocalitatiEmitentMessage = true;
            this.localitatiEmitentLoadComplete = false;
        }
    }

    onLocalitatiEmitentSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formEmitent.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formEmitent.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiEmitent(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiEmitentBlur() {
        const currentValue = this.localitatiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziEmitent(strada: string) {
        this.fetchStraziEmitentObservable(strada).subscribe();
    }

    private fetchStraziEmitentObservable(strada: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const localitateEmitentValue = this.formEmitent.get('id_localitate')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? taraEmitentValue : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? judetEmitentValue : undefined;
        const localitate = localitateEmitentValue && localitateEmitentValue !== -1 ? localitateEmitentValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziEmitentValue = strada;
            this.isStraziEmitentLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziEmitent = response;
                    this.isStraziEmitentLoading = false;
                    this.straziEmitentLoadComplete = true;
                    this.showStraziEmitentMessage = this.straziEmitent.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziEmitentLoading = false;
                    this.showStraziEmitentMessage = true;
                    this.straziEmitentLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziEmitent = [];
            this.showStraziEmitentMessage = true;
            this.straziEmitentLoadComplete = false;
            return of([]);
        }
    }

    onStraziEmitentSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formEmitent.controls['id_strada'].patchValue(selectedStrada.id);
            this.formEmitent.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziEmitent(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziEmitentBlur() {
        setTimeout(() => {
            const currentValue = this.straziEmitentControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziEmitentControl.patchValue('');
                this.formEmitent.controls['id_strada'].patchValue('');
                this.formEmitent.controls['name_strada'].patchValue('');
                this.lastStraziEmitentValue = '';
            }
        }, 2000);
    }

    addStraziEmitent() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziEmitentValue,
            id_country: this.formEmitent.get('id_tara')?.value,
            id_judet: this.formEmitent.get('id_judet')?.value,
            id_localitate: this.formEmitent.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziEmitentObservable(this.lastStraziEmitentValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziEmitent first then fill the input with the new street data
                    if (this.straziEmitent && this.straziEmitent.length > 0) {
                        const foundStrada = this.straziEmitent[0];
                        this.straziEmitentControl.setValue(foundStrada);
                        this.formEmitent.controls['id_strada'].patchValue(foundStrada.id);
                        this.formEmitent.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    fetchEntitatiExtern(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiExternLoading = true;
            this.commonService.searchEntitatiExtern(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiExtern = response;
                    this.isEntitatiExternLoading = false;
                    this.entitatiExternLoadComplete = true;
                    this.showEntitatiExternMessage = this.entitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiExternLoading = false;
                    this.showEntitatiExternMessage = true;
                    this.entitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiExtern = [];
            this.showEntitatiExternMessage = true;
            this.entitatiExternLoadComplete = false;
        }
    }

    onEntitateExternSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitentExtern(selectedEntitate);
        }
    }

    displayEntitateExtern(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateExternChange() {
        const currentValue = this.entitatiExternControl.value;

        if (typeof currentValue === 'string') {
            // this.formExtern.controls['id'].patchValue(null);
            this.formExtern.controls['denumire'].patchValue(currentValue);
        }
    }

    updateFormEmitentExtern(selectedEntitate: SearchEntitate) {
        this.formExtern.get('denumire')?.patchValue(selectedEntitate.denumire);
        this.formExtern.get('email')?.patchValue(selectedEntitate.email);
        this.formExtern.get('telefon')?.patchValue(selectedEntitate.telefon);

        if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
            this.tariExternControl.setValue({
                id: selectedEntitate.id_tara,
                name: selectedEntitate.name_tara
            })
            this.formExtern.get('id_tara')?.patchValue(selectedEntitate.id_tara);
            this.formExtern.get('name_tara')?.patchValue(selectedEntitate.name_tara);
            this.loadJudeteExtern(selectedEntitate.id_tara);
        }
        if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
            this.judeteExternControl.setValue({
                id: selectedEntitate.id_judet,
                name: selectedEntitate.name_judet
            })
            this.formExtern.get('id_judet')?.patchValue(selectedEntitate.id_judet);
            this.formExtern.get('name_judet')?.patchValue(selectedEntitate.name_judet);
        }
        if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
            this.fetchLocalitatiExtern(selectedEntitate.name_localitate);
            this.localitatiExternControl.setValue({
                id: selectedEntitate.id_localitate,
                name: selectedEntitate.name_localitate
            })
            this.formExtern.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
            this.formExtern.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
        }
        if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
            this.fetchStraziExtern(selectedEntitate.name_strada);
            this.straziExternControl.setValue({
                id: selectedEntitate.id_strada,
                name: selectedEntitate.name_strada
            })
            this.formExtern.get('id_strada')?.patchValue(selectedEntitate.id_strada);
            this.formExtern.get('name_strada')?.patchValue(selectedEntitate.name_strada);
        }

        this.formExtern.get('sector')?.patchValue(selectedEntitate.sector);
        this.formExtern.get('numar')?.patchValue(selectedEntitate.numar);
        this.formExtern.get('bloc')?.patchValue(selectedEntitate.bloc);
        this.formExtern.get('scara')?.patchValue(selectedEntitate.scara);
        this.formExtern.get('apartament')?.patchValue(selectedEntitate.apartament);
        this.formExtern.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
    }

    onTariExternChange(selectedTara: Generic): void {
        this.formExtern.controls['id_tara'].patchValue(selectedTara.id);
        this.formExtern.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteExtern(selectedTara.id);
        this.judeteExternControl.patchValue('');
        this.formExtern.controls['id_judet'].patchValue('');
        this.formExtern.controls['name_judet'].patchValue('');

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayTariExtern(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariExternBlur() {
        const currentValue = this.tariExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariExternControl.patchValue('');
            this.formExtern.controls['id_tara'].patchValue('');
            this.formExtern.controls['name_tara'].patchValue('');

            this.judeteExtern = [];
            this.filteredJudeteExtern = [];
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteExtern(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteExtern = results;
                    this.filteredJudeteExtern = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteExtern = [];
                },
            });
    }

    onJudeteExternChange(selectedJudet: Generic): void {
        this.formExtern.controls['id_judet'].patchValue(selectedJudet.id);
        this.formExtern.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiExternControl.patchValue('');
        this.formExtern.controls['id_localitate'].patchValue('');
        this.formExtern.controls['name_localitate'].patchValue('');

        this.straziExternControl.patchValue('');
        this.formExtern.controls['id_strada'].patchValue('');
        this.formExtern.controls['name_strada'].patchValue('');
    }

    displayJudeteExtern(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteExternBlur() {
        const currentValue = this.judeteExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteExternControl.patchValue('');
            this.formExtern.controls['id_judet'].patchValue('');
            this.formExtern.controls['name_judet'].patchValue('');

            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiExtern(localitate: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? this.formExtern.get('id_tara')?.value : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? this.formExtern.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiExternLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiExtern = response;
                    this.isLocalitatiExternLoading = false;
                    this.localitatiExternLoadComplete = true;
                    this.showLocalitatiExternMessage = this.localitatiExtern.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiExternLoading = false;
                    this.showLocalitatiExternMessage = true;
                    this.localitatiExternLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiExtern = [];
            this.showLocalitatiExternMessage = true;
            this.localitatiExternLoadComplete = false;
        }
    }

    onLocalitatiExternSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formExtern.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formExtern.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiExtern(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiExternBlur() {
        const currentValue = this.localitatiExternControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiExternControl.patchValue('');
            this.formExtern.controls['id_localitate'].patchValue('');
            this.formExtern.controls['name_localitate'].patchValue('');

            this.straziExternControl.patchValue('');
            this.formExtern.controls['id_strada'].patchValue('');
            this.formExtern.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziExtern(strada: string) {
        this.fetchStraziExternObservable(strada).subscribe();
    }

    private fetchStraziExternObservable(strada: string) {
        const taraExternValue = this.formExtern.get('id_tara')?.value;
        const judetExternValue = this.formExtern.get('id_judet')?.value;
        const localitateExternValue = this.formExtern.get('id_localitate')?.value;
        const tara = taraExternValue && taraExternValue !== -1 ? taraExternValue : undefined;
        const judet = judetExternValue && judetExternValue !== -1 ? judetExternValue : undefined;
        const localitate = localitateExternValue && localitateExternValue !== -1 ? localitateExternValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziExternValue = strada;
            this.isStraziExternLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziExtern = response;
                    this.isStraziExternLoading = false;
                    this.straziExternLoadComplete = true;
                    this.showStraziExternMessage = this.straziExtern.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziExternLoading = false;
                    this.showStraziExternMessage = true;
                    this.straziExternLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziExtern = [];
            this.showStraziExternMessage = true;
            this.straziExternLoadComplete = false;
            return of([]);
        }
    }

    onStraziExternSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formExtern.controls['id_strada'].patchValue(selectedStrada.id);
            this.formExtern.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziExtern(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziExternBlur() {
        setTimeout(() => {
            const currentValue = this.straziExternControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziExternControl.patchValue('');
                this.formExtern.controls['id_strada'].patchValue('');
                this.formExtern.controls['name_strada'].patchValue('');
                this.lastStraziExternValue = '';
            }
        }, 2000)
    }

    addStraziExtern() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziExternValue,
            id_country: this.formExtern.get('id_tara')?.value,
            id_judet: this.formExtern.get('id_judet')?.value,
            id_localitate: this.formExtern.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziExternObservable(this.lastStraziExternValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziExtern first then fill the input with the new street data
                    if (this.straziExtern && this.straziExtern.length > 0) {
                        const foundStrada = this.straziExtern[0];
                        this.straziExternControl.setValue(foundStrada);
                        this.formExtern.controls['id_strada'].patchValue(foundStrada.id);
                        this.formExtern.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiEmitent.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriEmitent.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterDirectiiDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiDestinatie.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriDestinatie.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTariEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariEmitent.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteEmitent.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTariExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariExtern.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteExtern(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteExtern.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END

    onRegistraturaTypeSelected(registraturaType: number) {
        const registratura_number = this.form.get('registratura_number') as FormControl;

        if (registraturaType === 2) {
            registratura_number.setValidators([Validators.required]);
            registratura_number.markAsUntouched();
        } else {
            registratura_number.patchValue('');
            registratura_number.clearValidators();
            registratura_number.setErrors(null);
            registratura_number.markAsUntouched();
        }

        this.form.updateValueAndValidity();
    }

    onProceduraIesireSelected(proceduraIesire: number) {
        const files = this.formFiles.get('files') as FormArray;

        if (proceduraIesire === 2) {
            files.setValidators([Validators.required]);
            files.markAsUntouched();
            this.showFormFiles = true;

            // FormDestinatie is always displayed when docData exists!
            if (!this.docData) {
                this.showFormDestinatie = true;
            }
        } else {
            files.clear();
            files.clearValidators();
            files.setErrors(null);
            files.markAsUntouched();
            this.showFormFiles = false;

            // FormDestinatie is always displayed when docData exists!
            if (!this.docData) {
                this.tableData.length = 0;
                this.showFormDestinatie = false;
            }
        }

        this.formFiles.updateValueAndValidity();
    }

    addSerie() {
        const sourceValue: number = this.form.controls['source'].value;

        if (!sourceValue || sourceValue === -1) return;

        const existing = this.sourceArr.find((item: Sursa) => item.id === sourceValue);

        if (existing) {
            return;
        } else {
            const sursa = this.surse.find((item: Generic) => item.id === sourceValue);
            if (sursa) {
                const sourceItem = {
                    id: sursa.id,
                    name: sursa.name,
                }
                this.sourceArr.push(sourceItem);
            };
        }
    }

    removeSerie(index: number) {
        this.sourceArr.splice(index, 1);
    }

    toggleEmitentInfoForm() {
        this.showEmitentInfoForm = !this.showEmitentInfoForm;
    }

    resetFormEmitent(entitateType: number) {
        const cnp_cui = this.formEmitent.get('cnp_cui') as FormControl;

        if (entitateType === 1 || entitateType === 2) {
            cnp_cui.setValidators([Validators.required]);
            cnp_cui.markAsUntouched();
        } else {
            cnp_cui.patchValue('');
            cnp_cui.clearValidators();
            cnp_cui.setErrors(null);
            cnp_cui.markAsUntouched();
        }

        this.formEmitent.patchValue({
            type: 1, // Hard coded emitent
            id: null,
            // id_address_type: -1,
            denumire: '',
            pers_contact: '',
            denumire_select: '',
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
            cnp_cui: '',
            email: '',
            telefon: '',
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
            sector: '-1',
            id_strada: null,
            name_strada: '',
            numar: '',
            bloc: '',
            scara: '',
            apartament: '',
            cod_postal: '',
            numar_deces: '',
            data_deces_input: '',
            person_status: false,
            observatii: '',
        });
        this.resetFormEmitentFields();

        this.formEmitent.updateValueAndValidity();
    }
    resetFormEmitentFields() {
        this.entitatiEmitent = [];
        this.entitatiEmitentByCNP = [];
        this.entitatiEmitentControl.setValue('');
        this.entitatiEmitentByCNPControl.setValue('');

        this.filteredDirectiiEmitent = this.directiiEmitent;
        this.directiiEmitentControl.setValue('');

        this.compartimenteEmitent = [];
        this.compartimenteEmitentControl.setValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.setValue('');

        this.filteredTariEmitent = this.tariEmitent;
        this.tariEmitentControl.setValue('');

        this.judeteEmitent = [];
        this.filteredJudeteEmitent = [];
        this.judeteEmitentControl.setValue('');

        this.localitatiEmitent = [];
        this.localitatiEmitentControl.setValue('')

        this.straziEmitent = [];
        this.straziEmitentControl.setValue('')

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();

        this.loadDefaultLocatieEmitent();
    }

    loadDefaultLocatieEmitent() {
        this.tariEmitentControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteEmitent(this.defaultTaraId);
            this.judeteEmitentControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiEmitent(this.defaultJudetLabel);
            this.localitatiEmitentControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formEmitent.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }
    loadDefaultLocatieExtern() {
        this.tariExternControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteExtern(this.defaultTaraId);
            this.judeteExternControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiExtern(this.defaultJudetLabel);
            this.localitatiExternControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formExtern.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }


    getIdentifier(directie_id: number, compartiment_id: number, user_id: number): string {
        const directieIdS = directie_id ? directie_id.toString() : '0';
        const compartimentIdS = compartiment_id ? compartiment_id.toString() : '0';
        const userIdS = user_id ? user_id.toString() : '0';
        const identifier = directieIdS + compartimentIdS + userIdS;
        return identifier;
    }

    addDestinatieToTableData() {
        const { directie_id, directie_name, compartiment_id, compartiment_name, user_id, user_name } = this.formDestinatie.value;
        if (!directie_id) { return };

        const newRowIndentifier = this.getIdentifier(directie_id, compartiment_id, user_id);
        const isRowAdded = this.tableData.some(row => this.getIdentifier(row.directie_id, row.compartiment_id, row.user_id) === newRowIndentifier);
        if (isRowAdded) { return };

        const newRow: DestinatieTableDataRow = {
            id: null,
            directie_id,
            directie_name,
            compartiment_id,
            compartiment_name,
            user_id,
            user_name,
            dosar_original: true,
        }

        this.tableData.push(newRow);
        this.formDestinatie.patchValue({
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
        });
        this.resetFormDestinatieFields();
    }
    resetFormDestinatieFields() {
        this.filteredDirectiiDestinatie = this.directiiDestinatie;
        this.directiiDestinatieControl.setValue('');

        this.compartimenteDestinatie = [];
        this.compartimenteDestinatieControl.setValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.setValue('');

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();
    }

    deleteTableDataRow(index: number) {
        this.tableData.splice(index, 1);
    }
    checkDocOriginal(index: number) {
        this.tableData[index].dosar_original = !this.tableData[index].dosar_original;
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.formFiles.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.toastService.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.dashboardService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.formFiles.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading = false;

                            this.toastService.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        // Handle error cases here
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    downloadFile(uploadedFile: FileUpload) {
        const fullPath = this.dashboardService.tempFileDownloadUrl;
        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    removeFile(index: number) {
        const files = this.formFiles.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.toastService.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    downloadAttachment(attachment: EmailAttachment) {
        let fullPath = this.inboxService.downloadUrl + attachment.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    findInvalidControls(formGroup: FormGroup) {
        const invalid = [];
        const controls = formGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    areFormsValid() {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();
        this.formEmitent.markAllAsTouched();
        this.formEmitent.updateValueAndValidity();
        this.formExtern.markAllAsTouched();
        this.formExtern.updateValueAndValidity();

        this.tipDocumenteControl.markAsTouched();
        this.entitatiEmitentByCNPControl.markAsTouched();

        if (
            this.sourceArr.length === 0 ||
            this.form.invalid ||
            this.formEmitent.invalid ||
            this.formExtern.invalid ||
            (this.showFormFiles && this.formFiles.invalid && !(this.inboxEmailsData || this.inboxAttachementsData)) ||
            (this.showFormDestinatie && this.tableData.length === 0)
        ) {
            console.log('Invalid in this.form:', this.findInvalidControls(this.form));
            console.log('Invalid in this.formEmitent:', this.findInvalidControls(this.formEmitent));
            console.log('Invalid in this.formExtern:', this.findInvalidControls(this.formExtern));
            return false;
        } else {
            return true;
        }
    }

    submitForm(closeModal: boolean = false) {
        if (this.areFormsValid()) {
            Swal.fire({
                title: helper.dialogConfig.commonTitles.areYouSure,
                text: 'O să înregistrați documentul completat în registratură!',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: helper.dialogConfig.buttonLabels.close,
                confirmButtonColor: helper.dialogConfig.colorButtons.standard,
                confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
                showLoaderOnConfirm: true,
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.storeDoc(closeModal);
                }
            });
        } else {
            Swal.fire({
                title: helper.dialogConfig.headers.error,
                text: 'Verificați din nou câmpurile obligatorii şi validitatea informațiilor.',
                icon: 'error',
                confirmButtonText: helper.dialogConfig.buttonLabels.close
            });
        };
    }

    storeDoc(closeModal: boolean = false) {
        this.isLoading = true;

        const extern_date_input = this.form.value.extern_date_input;
        const data_comunicare_pv_input = this.form.value.data_comunicare_pv_input;
        const data_deces_input = this.formEmitent.value.data_deces_input;

        const document = {
            ...this.form.value,
            source: 0, // Hard coded
            sourceArr: this.sourceArr,
            extern_date: extern_date_input ? formatDate(extern_date_input, 'yyyy-MM-dd', 'en-US') : '',
            data_comunicare_pv: data_comunicare_pv_input ? formatDate(data_comunicare_pv_input, 'yyyy-MM-dd', 'en-US') : '',
            emitent: {
                ...this.formEmitent.value,
                data_deces: data_deces_input ? formatDate(data_deces_input, 'yyyy-MM-dd', 'en-US') : '',
            },
            extern_emitent: this.formExtern.value,
            destinatie: this.tableData.map((item, index) => {
                item.id = index + 1
                return item;
            }),
            // docData
            id_document: this.docData ? this.docData.id_document : null,
            id_document_activity: this.data.idDocumentActivity,

            // inboxEmailsData || inboxAttachementsData
            email_ids: [],
            email_attachment_ids: [],
            selectedEmail: null,

            // informatii: null, // needed ?
            // amenda: null, // needed ?
        };

        if (this.inboxEmailsData) {
            document.email_ids = this.inboxEmailsData ? this.inboxEmailsData.map(record => record.id) : [];
            document.email_attachment_ids = [];
            document.selectedEmail = this.selectedEmail;
        }

        if (this.inboxAttachementsData) {
            document.email_ids = this.selectedEmail ? [this.selectedEmail.id] : [];
            document.email_attachment_ids = this.inboxAttachementsData ? this.inboxAttachementsData.selectedAttachments.map(attachment => attachment.id) : [];
            document.selectedEmail = this.selectedEmail;
        }

        const payload = {
            document,
            files: this.formFiles.value.files,
        }

        // console.log(payload);
        this.dashboardService
            .storeDocumentIntrare(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: `${res.data.reg_number} - ${res.data.reg_date}`,
                        text: `Documentul înregistrat cu succes cu numărul ${res.data.reg_number} - ${res.data.reg_date}`,
                        icon: 'success',
                        showCancelButton: true,
                        cancelButtonColor: helper.dialogConfig.colorButtons.info,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        confirmButtonColor: helper.dialogConfig.colorButtons.secondary,
                        confirmButtonText: 'Deschide Document',
                        showLoaderOnConfirm: true,
                        // reverseButtons: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            // Redirect to document url when Confirmed(Deschide Document) is clicked
                            const url = `#/documente?id=${res.data.id_document}`;
                            window.open(url, '_blank');

                            // Return false to prevent the modal from closing
                            return false;
                        }
                    }).then((result) => {
                        // This will only trigger when Cancel is clicked
                        if (result.isDismissed) {
                            if (closeModal) {
                                this.dialogRef.close({ success: true, resData: res.data });
                            } else {
                                // Clear files when modal is not closed
                                const files = this.formFiles.get('files') as FormArray;
                                files.clear();
                            }
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
